import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';

import Bs4GenericField from './Bs4GenericField'
import Bs4MainDispatch from '../../Bs4MainDispatch'
import * as Bs4Utils from '../../Bs4Components/Bs4Utils'

export default class Bs4Timer extends Bs4GenericField {
  static STARTED = 'started';
  static STOPPED = 'stopped';
  
  getShortValue(full) {    
    return JSON.stringify(this.getValue());
  }

  zeroPad2 = (num) => String(num).padStart(2, '0')
  
  getTimeTextSeconds = (seconds) => {
    let minutes = parseInt(seconds / 60);
    let hours = parseInt(minutes / 60);
    let days = parseInt(hours / 24);
    seconds -= minutes * 60;
    minutes -= hours * 60;
    hours -= days * 24;

    return days+':'+this.zeroPad2(hours)+':'+this.zeroPad2(minutes)+':'+this.zeroPad2(seconds)
  }

  getTimeTextDate = (start, now, addSeconds) => {
    let seconds = parseInt((now.getTime() - start.getTime()) / 1000 + addSeconds);
    return this.getTimeTextSeconds(seconds);
  }

  ViewComponentField = (props) => {
    const formField = this;
    const [value, setValue] = React.useState(() => this.getValue());
    const [error, setError] = React.useState(Bs4GenericField.NO_ERROR)
    const [current, setCurrent] = React.useState(value?.current || Bs4Timer.STOPPED)
    const [addSeconds, setAddSeconds] = React.useState(value?.addSeconds || 0);
    const [lastStart, setLastStart] = React.useState(Bs4Utils.getValidDate(value?.lastStart) || new Date());
    const [timeStr, setTimeStr] = React.useState(() => this.getTimeTextSeconds(addSeconds));
    const fontSize = React.useMemo(() => 18 * (parseFloat(this.props?.field?.iconSizeMultiplier) || 3));
    this.refFocus = React.useRef(); 

    React.useEffect(() => {
      setCurrent(value?.current || Bs4Timer.STOPPED);
      setAddSeconds(value?.addSeconds || 0);
      setLastStart(Bs4Utils.getValidDate(value?.lastStart) || new Date())
    }, [value, setCurrent, setAddSeconds, setLastStart]);    

    React.useEffect(() => {
      this.notValidElementDom = (text) => {setError({error: true, helperText: text})}
      this.elementSetTimer = (value) => {this.setValue(value);}
      this.on(Bs4GenericField.CHANGE, (field, oldValue, newValue) => {
        const value = this.getValue();
        setValue(value);
        setTimeStr(this.getTimeTextSeconds(value?.addSeconds || 0));
        if (Boolean(error.error)) setError(Bs4GenericField.NO_ERROR);
      })    
    }, [error]);

    React.useEffect(() => {
      let prevStr = '';
      let intervalId = null;
      if (current === Bs4Timer.STARTED) {
        intervalId = setInterval(() => {
          const str = this.getTimeTextDate(lastStart, new Date(), addSeconds);
          if (prevStr != str) {
            prevStr = str;
            setTimeStr(str);          
          }
        }, 333) 
      }
  
      return () => clearInterval(intervalId);
    }, [current, addSeconds, lastStart])

    const handlePausePlay = (e) => {     
      // console.log('...Timer...', value) 
      // if (lastStart) {
      //   setLastStart(null);
      //   setAddSeconds(addSeconds + (new Date().getTime() - lastStart.getTime()) / 1000);
      // } else {
      //   setLastStart(new Date());
      // }

      Bs4MainDispatch.commandParser('Bs4UpdateTimer', {currFormId: this.props.field.formId}, this.bs4KartotekaId);
    }

    return (      
      <FormControl fullWidth error={error.error}>
        {!this.props.field.hideLabel ? <FormLabel><formField.Bs4Label/></FormLabel> : null}
        <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={1}>
          <IconButton ref={this.refFocus} onClick={handlePausePlay} sx={{fontSize: fontSize, width: (fontSize * 1.2), height: (fontSize * 1.2)}}>
            {current === Bs4Timer.STARTED ? <i className="fa-solid fa-pause"/> : <i className="fa-solid fa-play"/>}
          </IconButton>
          <Typography>{timeStr}</Typography>
        </Stack>
        <FormHelperText>{error.helperText}</FormHelperText>
      </FormControl>
    );
  }
}